import { render, staticRenderFns } from "./NextPrevArticle.vue?vue&type=template&id=2813e5be&"
import script from "./NextPrevArticle.ts?vue&type=script&lang=ts&"
export * from "./NextPrevArticle.ts?vue&type=script&lang=ts&"
import style0 from "./NextPrevArticle.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports